export * from  "react-i18next";


export const createPageContentTranslationKey = (customId) => (translationKey) => {
  return 'system_pages.' + customId + '.content.' + translationKey;
}
